import styled from 'styled-components'

export const Content = styled.div`
  margin: 8px 16px 24px 16px;
`
